import { atlas } from 'graphql/tags'

export const StyleDataQuery = atlas`#graphql
  query GetManageImagesStyleData(
    $styleId: ID!,
    $collectionId: ID!,
  ) {
    getManageImagesStyleData(
      input: {
        styleId: $styleId,
        collectionId: $collectionId,
      }
    ) {
      styleId
      styleNumber
      styleName
      fabrication {
        name
        code
      }
      silhouette {
        name
        code
      }
      images {
        id
        url
        orderNbr
        fileName
      }
      styleColors {
        id
        name
        code
        imageId
        imageUrl
        swatch {
          hex
          url
          fileName
        }
      }
    }
  }
`

export const UnmatchedUploadsQuery = atlas`#graphql
  query ListUnmatchedUploads($collectionId: ID!, $searchFileName: String, $offset: Int, $limit: Int) {
    listUnmatchedUploads(
      input: {
        collectionId: $collectionId
        limit: $limit
        offset: $offset
        filters: { searchFileName: $searchFileName, mediaType: IMAGE }
      }
    ) {
      totalCount
      uploads {
        id
        url
        fileName
        unmatchedUploadId
      }
    }
  }
`

export const NavigationProductsQuery = atlas`#graphql
  query NavigationProducts($filter: ProductsFilter, $orderBy: ProductOrderByInput) {
    products(
      filter: $filter
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        node {
          id
        }
      }
    }
  }

`
